import { useEffect, useState } from "react";

import {
  getRaspberryDiagnostics,
  RaspberryDiagnosticsState,
  subscribeRaspberryDiagnostics,
} from "../utils/raspberryDiagnostics";

/**
 * Expone el estado del puente Raspberry a React.
 *
 * El disparo a la Pi ocurre fuera del arbol de React (dentro del SDK, en addEventAll), asi
 * que el store notifica por suscripcion. React 17 no tiene useSyncExternalStore, de ahi el
 * useState + useEffect.
 */
export const useRaspberryDiagnostics = (): RaspberryDiagnosticsState => {
  const [state, setState] = useState<RaspberryDiagnosticsState>(getRaspberryDiagnostics);

  useEffect(() => subscribeRaspberryDiagnostics(() => setState(getRaspberryDiagnostics())), []);

  return state;
};

export default useRaspberryDiagnostics;
